export const fileInputAccept =
  'image/x-png,image/jpeg,.png,.jpg,.jpeg, image/heic, image/heif';
